import type { Components, Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import { elevation, radius } from '../palette';

export const inputs: Components<Theme> = {
  MuiTextField: { defaultProps: { size: 'small', fullWidth: true } },
  MuiSelect: { defaultProps: { size: 'small' } },
  MuiOutlinedInput: {
    styleOverrides: {
      root: ({ theme: t }) => ({
        borderRadius: radius.control, backgroundColor: t.palette.background.paper,
        '& .MuiOutlinedInput-notchedOutline': { borderColor: t.palette.divider },
        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: t.palette.text.disabled },
        '&.Mui-focused': { boxShadow: `0 0 0 3px ${alpha(t.palette.secondary.main, 0.14)}` },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: t.palette.secondary.main, borderWidth: 1 },
        '&.Mui-error.Mui-focused': { boxShadow: `0 0 0 3px ${alpha(t.palette.error.main, 0.12)}` },
        '&.Mui-error .MuiOutlinedInput-notchedOutline': { borderColor: t.palette.error.main },
      }),
    },
  },
  MuiInputLabel: { styleOverrides: { root: ({ theme: t }) => ({ color: t.palette.text.secondary, '&.Mui-focused': { color: t.palette.secondary.dark } }) } },
  MuiFormHelperText: { styleOverrides: { root: { marginInline: 2, marginTop: 6 } } },
  MuiInputAdornment: { styleOverrides: { root: ({ theme: t }) => ({ color: t.palette.text.disabled }) } },
  MuiAutocomplete: {
    styleOverrides: {
      paper: { boxShadow: elevation.float, marginTop: 4 },
      option: { borderRadius: radius.mark, marginInline: 4, fontSize: '0.875rem' },
    },
  },
  MuiMenu: { styleOverrides: { paper: { boxShadow: elevation.float, marginTop: 4 }, list: { padding: 4 } } },
  MuiMenuItem: {
    styleOverrides: {
      root: ({ theme: t }) => ({
        borderRadius: radius.mark, fontSize: '0.875rem', minHeight: 36, '&.Mui-focusVisible': { outlineOffset: -2 },
        '&.Mui-selected': { backgroundColor: t.palette.action.selected, '&:hover': { backgroundColor: t.palette.action.selected } },
      }),
    },
  },
};
